export default __webpack_public_path__ + "static/media/starting-image.052fb537.jpg";